// Utils
import { getSafe } from '../../utils/Object'
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default
{
    name: 'app-footer',

    data()
    {
        return {
            footerIsFixedBottom: false
        }
    },

    computed:
    {
        content()
        {
            const content = this.$root.contentPage.footer.acf

            if (getSafe(() => content.label_copyright
                && content.label_copyright.trim() !== ''))
            {
                content.label_copyright = content.label_copyright.replace('[CURRENT_YEAR]', new Date().getFullYear())
            }

            return content
        }
    },

    created()
    {
        // Events
        this.eventHub.$on('window:resize', this._onResize)

        if (this.$route.name === this.$root.CONFIG.pages['404'].name)
        {
            this.eventHub.$on('page-404:container-mounted', this._on404ContainerMounted)
        }
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('window:resize', this._onResize)

        if (this.$route.name === this.$root.CONFIG.pages['404'].name)
        {
            this.eventHub.$off('page-404:container-mounted', this._on404ContainerMounted)
        }
    },

    methods:
    {
        // Events
        _onResize()
        {
            this._fixFooter()

            this.$nextTick(() =>
            {
                this.eventHub.$emit('app-footer:resized')
            })
        },

        _on404ContainerMounted()
        {
            this.footerIsFixedBottom = false
            this.$el.style.top = '0px'

            this.$nextTick(() =>
            {
                this._fixFooter()
            })
        },

        //
        _fixFooter()
        {
            this._elRect = getAbsoluteBoundingRect(this.$el)

            if (this.$route.name === this.$root.CONFIG.pages['404'].name)
            {
                this.$404Container = document.querySelector('.js-page-container')

                if (this.$404Container)
                {
                    this.$nextTick(() =>
                    {
                        this._404ContainerRect = getAbsoluteBoundingRect(this.$404Container)

                        if (this._elRect.height + this._elRect.margins.y + this._404ContainerRect.height + this._404ContainerRect.margins.y < this.$root.height)
                        {
                            this.footerIsFixedBottom = true

                            this.$el.style.top = `${this.$root.height - this._elRect.height + this._elRect.margins.y}px`
                        }
                    })
                }
            }
            else if (this.$root.pageHeight < this.$root.height)
            {
                this.footerIsFixedBottom = true

                this.$el.style.top = `${this.$root.height - this._elRect.height}px`
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-footer/script.js